import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AppService{
  private currentUserIdSubject = new BehaviorSubject<string>('');
  public currentUserId$: Observable<string> = this.currentUserIdSubject.asObservable();
  
  constructor() { }
  setCurrentUserId(userId: string): void {
    this.currentUserIdSubject.next(userId);
  }

  getCurrentUserId(): string {
    return this.currentUserIdSubject.value;
  }

  clearCurrentUserId(): void {
    this.currentUserIdSubject.next('');
  }
}
